module.exports = __webpack_public_path__ + "img/1f377.b8f77df.svg";